import React from 'react';
import { useTranslation } from 'react-i18next';
import BalancesTab from './components/BalancesTab';
import FinanceSectionPage from './components/FinanceSectionPage';

/** What each child, or each family, still owes - and the payments recorded against it. */
const FinanceDebtsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <FinanceSectionPage title={t('nav.financeItems.debts')} description={t('finance.pages.debtsDescription')}>
      {({ kindergartenId, kindergartenName }) => <BalancesTab kindergartenId={kindergartenId} kindergartenName={kindergartenName} />}
    </FinanceSectionPage>
  );
};

export default FinanceDebtsPage;
